export const TAX = 0
export const DELIVERY_FEE = 5
export const CONTAINER_FEE = 0

export const openingHours = [11, 19]
export const allowedHours = [
  // { label: '10-11am', value: 10 },
  { label: '11am–12pm', value: 11 },
  { label: '12–1pm', value: 12 },
  // { label: '1–2pm', value: 13 },
  // { label: '2–3pm', value: 14 },
  // { label: '3–4pm', value: 15 },
  // { label: '4–5pm', value: 16 },
  // { label: '5–6pm', value: 17 },
  { label: '6–7pm', value: 18 },
  { label: '7–8pm', value: 19 }
  // { label: '8–9pm', value: 20 },
  // { label: '9–10pm', value: 21 }
]

export const promotions = {
  amount: 5,
  currencyCode: 'RM'
}
